import { Reveal } from "./Reveal";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="py-24 md:py-36 px-6 md:px-12 bg-[#0a0a0a] text-white">
    <div className="max-w-[1600px] mx-auto text-center">
      <Reveal>
        <h2 className="font-head uppercase tracking-tighter leading-[0.9] text-4xl md:text-7xl xl:text-8xl mb-8">
          One recruitment network.
          <br />
          <span className="text-[#52525b]">Multiple European opportunities.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="max-w-2xl mx-auto space-y-1 font-body text-[#a1a1aa] text-lg mb-12">
          <p><span className="text-white">Employers:</span> find qualified international talent.</p>
          <p><span className="text-white">Candidates:</span> discover legitimate international opportunities.</p>
          <p><span className="text-white">Agencies:</span> build trusted recruitment partnerships.</p>
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="flex flex-wrap justify-center gap-4">
          <a href="#hire" data-testid="final-hire" className="bg-[#ff3b30] hover:bg-[#ff5248] text-white font-head uppercase text-sm tracking-wide px-8 py-4 transition-colors duration-300">
            Hire Talent
          </a>
          <a href="#find-job" data-testid="final-find" className="border border-[#3f3f46] hover:border-[#ff3b30] text-white font-head uppercase text-sm tracking-wide px-8 py-4 transition-colors duration-300">
            Find a Job
          </a>
          <a href="#partner" data-testid="final-partner" className="border border-[#3f3f46] hover:border-[#ff3b30] text-white font-head uppercase text-sm tracking-wide px-8 py-4 transition-colors duration-300">
            Partner With Daab
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
